import { __awaiter, __generator } from "tslib";
import { prepareUrl } from "./utils";

var WebRtcPlayer =
/** @class */
function () {
  function WebRtcPlayer() {
    var _this = this;

    this.pc = new RTCPeerConnection();
    this.stream = new MediaStream();

    this.pc.ontrack = function (event) {
      if (_this.ontrack) {
        _this.ontrack(event);
      }
    };
  }

  WebRtcPlayer.prototype.play = function (url) {
    return __awaiter(this, void 0, void 0, function () {
      var conf, offer, session;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.pc.addTransceiver("audio", {
              direction: "recvonly"
            });
            this.pc.addTransceiver("video", {
              direction: "recvonly"
            });
            conf = prepareUrl(url);
            return [4
            /*yield*/
            , this.pc.createOffer()];

          case 1:
            offer = _a.sent();
            return [4
            /*yield*/
            , this.pc.setLocalDescription(offer)];

          case 2:
            _a.sent();

            return [4
            /*yield*/
            , fetch(conf.apiUrl, {
              method: "POST",
              body: JSON.stringify({
                api: conf.apiUrl,
                tid: conf.tid,
                streamurl: conf.streamUrl,
                clientip: null,
                sdp: offer.sdp
              })
            }).then(function (res) {
              return res.json();
            }).then(function (res) {
              return res;
            }).catch(function (e) {
              return e;
            })];

          case 3:
            session = _a.sent();
            return [4
            /*yield*/
            , this.pc.setRemoteDescription(new RTCSessionDescription({
              type: "answer",
              sdp: session.sdp
            }))];

          case 4:
            _a.sent();

            return [2
            /*return*/
            , session];
        }
      });
    });
  };

  WebRtcPlayer.prototype.close = function () {
    this.pc && this.pc.close();
  };

  WebRtcPlayer.prototype.ontrack = function (event) {
    this.stream.addTrack(event.track);
  };

  return WebRtcPlayer;
}();

export default WebRtcPlayer;